// this.elText
export function scrollToTop(el: Window) {
    if (!el) {
        return;
    }

    el.scrollTo({
        top: 0,
    });
}

export function scrollToRight(el: Window) {
    if (!el) {
        return;
    }

    el.scrollTo({
        left: 1000 * 1000,
    });
}
